import {makeStyles} from "@material-ui/core/styles";
import createStyles from "@material-ui/styles/createStyles";
import React, {useEffect} from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import Drawer from "@material-ui/core/Drawer";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Tooltip from '@material-ui/core/Tooltip';
import ListItemText from "@material-ui/core/ListItemText";
import useTheme from "@material-ui/core/styles/useTheme";
import Routes from "./routes";
import {BrowserRouter, Switch, Link, Route, Redirect} from "react-router-dom";
import {useTranslation} from "react-i18next";
import HomeToolbar from "../_components/toolbar.home.component";
import {useNeeds} from "../_helpers/needs";
import {
    Backdrop,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    useMediaQuery
} from "@material-ui/core";
import {loadingContext} from '../_context/loading-context';
import {tabContext} from '../_context/tab-context';
import { useHistory } from "react-router-dom";
import { useRouteMatch, useLocation  } from "react-router-dom";

const drawerWidth = 240;
const useStyles = makeStyles(theme => (createStyles({
    root: {
        display: 'flex',
        height: '100vh'
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        background: theme.palette.neutral.main,
        color: theme.palette.neutral.emphasisText.medium,
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9) + 1,
        },
    },backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
    },
    content: {
        display: 'flex',
        flexFlow: 'column',
        height: "100%",
        width: "100%",
        overflow: 'auto'
    },
    main: {
        flex: 1,
        padding: theme.spacing(3),
        overflow: 'auto'
    },
    icon: {
      '&': {
          color: theme.palette.neutral.emphasisText.medium,
      }
    },
    selectedIcon: {
      '&': {
          color: theme.palette.primary.main,
      }
    },
    grow: {
        flexGrow: 1,
    },
})));

const HomePage = (props) => {
    const theme = useTheme();
    const classes = useStyles();

    const baseRouter = props.baseRouter;

    const { t } = useTranslation();

    const [open, setOpen] = React.useState(false);

    let match = useRouteMatch();
    const location = useLocation();
    const currentRoute = location.pathname;
    const [hasNeeds, NEEDS] = useNeeds();

    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };

    const [loading, setLoading] = React.useState(false);
      const handleClose = () => {
        setLoading(false);
      };

      const routerRef = React.createRef();
      let history = useHistory();

    return (
        <div className={classes.root}>
            <CssBaseline/>
                <loadingContext.Provider value={{loading: loading, startLoading: () => {setLoading(true)}, stopLoading: () =>{setLoading(false)}}}>
                    
                            <AppBar
                                position="fixed"
                                className={clsx(classes.appBar, {
                                    [classes.appBarShift]: open,
                                })}>
                                <HomeToolbar
                                    routerRef={baseRouter}
                                    changeTheme={props.changeTheme}
                                    handleDrawerOpen={handleDrawerOpen}
                                    handleDrawerClose={handleDrawerClose}
                                    open={open}
                                />
                            </AppBar>
                            <Switch ref={routerRef}>
                           
                            
                                <tabContext.Provider value={{currentTab: currentRoute, goTo: (res, id=null) => {
                                if (id === null) {
                                    history.replace(`/home/${res}`);
                                } else {
                                    history.replace(`/home/${res}?id=${id}`);
                                }
                            }}}>
                                <Drawer
                                    variant="permanent"
                                    className={clsx(classes.drawer, {
                                        [classes.drawerOpen]: open,
                                        [classes.drawerClose]: !open,
                                    })}
                                    classes={{
                                        paper: clsx({
                                            [classes.drawerOpen]: open,
                                            [classes.drawerClose]: !open,
                                        }),
                                    }}
                                >
                                    <div className={classes.toolbar}>
                                        <IconButton onClick={handleDrawerClose}>
                                            {theme.direction === 'rtl' ? <ChevronRightIcon/> : <ChevronLeftIcon/>}
                                        </IconButton>
                                    </div>
                                    <Divider/>
                                    <List>
                                        {Routes
                                            .filter(route => hasNeeds(route.needs))
                                            .map((prop) =>(
                                                  <ListItem key={prop.title} to={prop.path } button component={Link}>
                                                    <ListItemIcon className={`/home/${prop.path}` === currentRoute? classes.selectedIcon: classes.icon}>
                                                        <Tooltip title={t(prop.title)} aria-label={t(prop.title)}>
                                                            {<prop.icon/>}
                                                        </Tooltip>
                                                    </ListItemIcon>
                                                    <ListItemText primary={t(prop.title)}/>
                                                </ListItem>
                                                ))}
                                    </List>
                                </Drawer>


                                <div className={classes.content}>
                                    <div className={classes.toolbar}/>
                                    <main className={classes.main}>
                                    <Route exact path="/home/">
                                        <Redirect to="/home/students" />
                                    </Route>
                                        {Routes
                                            .filter(route => hasNeeds(route.needs))
                                            .map((prop) => <Route key={prop.title} path={`/home/${prop.path}`} component={prop.component}/>)
                                        }
                                    </main>
                                </div>
                                     </tabContext.Provider>
                            </Switch>

                    <Backdrop className={classes.backdrop} open={loading} onClick={handleClose}>
                    <CircularProgress color="inherit" />
                  </Backdrop>

                        

            </loadingContext.Provider>
        </div>
    );
}

export default HomePage;